// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GroupAudioCall__container-c18699 {
  width: 100%;
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: minmax(72px, auto) auto auto auto 1fr;
  position: relative;
}

.GroupAudioCall__avatar-container-de0ec6 {
  margin-top: 8px;
  margin-bottom: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.GroupAudioCall__members-quantity-d6b90a {
  font: var(--font-subtitle-2);
  letter-spacing: var(--font-spacing-subtitle-2);
  align-self: flex-start;
  padding: 0 var(--indent-16px) 4px;
  margin-top: 32px;
  color: var(--addition-50);
  opacity: 0.7;
}

.GroupAudioCall__member-list-container-e38054 {
  width: 100%;
  flex: 1 1;
  overflow-y: auto;
}

.GroupAudioCall__member-list-container-e38054::-webkit-scrollbar-track {
  background-color: var(--addition-80);
}

.GroupAudioCall__actions-panel-d2d5e6 {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  background-color: var(--addition-100);
  border-radius: 100px;
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/CallView/CompactCallView/GroupAudioCall/GroupAudioCall.styles.m.css"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,2BAAA;EACA,yDAAA;EACA,kBAAA;AACF;;AAEA;EACE,eAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,4BAAA;EACA,8CAAA;EACA,sBAAA;EACA,iCAAA;EACA,gBAAA;EACA,yBAAA;EACA,YAAA;AACF;;AAEA;EACE,WAAA;EACA,SAAA;EACA,gBAAA;AACF;;AAEA;EACE,oCAAA;AACF;;AAEA;EACE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,qCAAA;EACA,oBAAA;AACF","sourcesContent":[".container {\n  width: 100%;\n  display: grid;\n  grid-template-columns: 100%;\n  grid-template-rows: minmax(72px, auto) auto auto auto 1fr;\n  position: relative;\n}\n\n.avatar-container {\n  margin-top: 8px;\n  margin-bottom: 24px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.members-quantity {\n  font: var(--font-subtitle-2);\n  letter-spacing: var(--font-spacing-subtitle-2);\n  align-self: flex-start;\n  padding: 0 var(--indent-16px) 4px;\n  margin-top: 32px;\n  color: var(--addition-50);\n  opacity: 0.7;\n}\n\n.member-list-container {\n  width: 100%;\n  flex: 1 1;\n  overflow-y: auto;\n}\n\n.member-list-container::-webkit-scrollbar-track {\n  background-color: var(--addition-80);\n}\n\n.actions-panel {\n  position: absolute;\n  bottom: 20px;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: var(--addition-100);\n  border-radius: 100px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `GroupAudioCall__container-c18699`,
	"avatar-container": `GroupAudioCall__avatar-container-de0ec6`,
	"avatarContainer": `GroupAudioCall__avatar-container-de0ec6`,
	"members-quantity": `GroupAudioCall__members-quantity-d6b90a`,
	"membersQuantity": `GroupAudioCall__members-quantity-d6b90a`,
	"member-list-container": `GroupAudioCall__member-list-container-e38054`,
	"memberListContainer": `GroupAudioCall__member-list-container-e38054`,
	"actions-panel": `GroupAudioCall__actions-panel-d2d5e6`,
	"actionsPanel": `GroupAudioCall__actions-panel-d2d5e6`
};
module.exports = ___CSS_LOADER_EXPORT___;
